import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { languageFieldActions } from "Framework/redux/actions/index";
import { MOBILEMENU, MAINMENU } from "Framework/consts/menuTypes";
import { MainMenuWrapper, MenuItemText, MenuItemWrapper, MenuButtonWrapper } from "../Menu/";
import { useGlobal } from "reactn";
import styled from "styled-components";
import { toggleAria } from "Helpers/AriaHelper";
import { HeaderButton } from "BaseComponents/Button";

export const LanguageLink = ({ LinkText, MenuType, Depth }) => {
	const state = useSelector(({ languageField }) => languageField);
	const dispatch = useDispatch();
	const [theme] = useGlobal("theme");
	let btnRef = useRef();

	let handleClick = (e) => {
		e.preventDefault();
		toggleAria(btnRef.current, "aria-expanded");

		dispatch(languageFieldActions.toggle(state.show));
	};

	return MenuType == MOBILEMENU ? (
		<MenuItemWrapper
			onClick={(e) => handleClick(e)}
			bgColor={theme.colors.lightgrey}
			Depth={Depth}
			MenuType={MAINMENU}
			borderBottom={`1px solid ${theme.colors.grey}`}
		>
			<MenuItemText lang="en" Color="black" MenuType={MAINMENU} IsExpanded="false">
				Language
			</MenuItemText>
			<MenuButtonWrapper IconSize="28px">
				<a className="element-link parent-menu-link">
					<i className="icon-globe"></i>
				</a>
			</MenuButtonWrapper>
		</MenuItemWrapper>
	) : (
		<HeaderButton
			ref={btnRef}
			className="element-link parent-menu-link"
			onClick={(e) => handleClick(e)}
		>
			<i className="icon-globe"></i>

			<span>Language</span>
		</HeaderButton>
	);
};
